import { dataTypeEnum, getData } from 'utils';
import { Grid, Step, StepContent, StepLabel, Stepper } from '@material-ui/core';
import { ProviderApi } from 'services';
import { useHistory } from 'react-router-dom';
import MaiaLogo from 'components/MaiaLogo';
import RegisterCompany from '../RegisterCompany';
import RegisterLayout from 'pages/RegisterLayout';
import routes from 'config/routes';
import sideImage from '_assets/register/register-company-image.svg';
import StepComponent from 'components/StepComponent';
import useStyles from './styles';

const steps = ['Inscription', 'Finalisation'];

const CompanyParametersManager = (props) => {
  const classes = useStyles();
  const history = useHistory();

  const handleStepChange = async (step, data) => {
    if (step === 2) {
      try {
        const { email, firstName, lastName } = await getData(dataTypeEnum.userData);
        await props.createAccount(email, firstName, lastName);

        await ProviderApi.createProvider();
        localStorage.removeItem('companyData');
        localStorage.removeItem('placeData');
        localStorage.removeItem('userData');
        history.push(routes.register.end.root);
      } catch (error) {
        console.warn('Error While creating provider', error);
      }
    }
  };

  const SideComponent = () => (
    <Grid container direction="column" style={{ height: 'auto' }}>
      <Grid container item justifyContent="center">
        <MaiaLogo />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '8vh' }}>
        <img src={sideImage} alt="Files" width={200} />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '3vh' }}>
        <div className={classes.stepper}>
          <Stepper activeStep={0} orientation="vertical">
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <StepComponent step={index} stepNb={2} />
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </div>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <RegisterCompany onChange={(step, data) => handleStepChange(step, data)} setStepNb={props.setStepNb} />
    </RegisterLayout>
  );
};

export default CompanyParametersManager;
